var _filter, _filter2, _marker, _marker2, _marker3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudviewNodfloArchitecture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 420",
    width: 550,
    height: 420,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cvBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#eff6ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#dbeafe"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#e0f2fe"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cvCard",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgba(255,255,255,0.96)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgba(255,255,255,0.88)"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cloudGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#60a5fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodfloGrad2",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fb923c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#ea580c"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edgeGrad",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#22d3ee"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0891b2"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "cvShadow",
    x: "-15%",
    y: "-15%",
    width: "130%",
    height: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 18,
    floodColor: "#0f172a",
    floodOpacity: 0.12
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "cvSoftShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 8,
    floodColor: "#0f172a",
    floodOpacity: 0.08
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowCloud2",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#2563eb"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowNodflo",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#ea580c"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowEdge",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L9,3 z",
    fill: "#0891b2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.5) translate(0, 40)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 0,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 24,
    fontWeight: 700,
    fill: "#1e3a8a",
    textAnchor: "middle"
  }, "CloudView + NodFlo IIoT Architecture"), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 28,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "CloudView manages devices and dashboards; NodFlo executes workflows and exchanges data in real time"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,80)",
    filter: "url(#cvShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 150,
    rx: 16,
    fill: "url(#cvCard)",
    stroke: "#93c5fd",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 45,
    rx: 180,
    ry: 38,
    fill: "url(#cloudGrad)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 42,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u2601 CloudView Platform"), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 60,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#dbeafe",
    textAnchor: "middle"
  }, "MQTT Broker \u2022 REST API \u2022 Device Manager"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 36,
    rx: 6,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Dashboards")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152,98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 36,
    rx: 6,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Historical Data")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(264,98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 36,
    rx: 6,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Device Mgmt")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(376,98)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 36,
    rx: 6,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 42,
    y: 23,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Alarms"))), /*#__PURE__*/React.createElement("path", {
    d: "M550 230 L550 270",
    stroke: "#2563eb",
    strokeWidth: 3,
    markerEnd: "url(#arrowCloud2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490,
    y: 238,
    width: 120,
    height: 18,
    rx: 4,
    fill: "#fff",
    stroke: "#2563eb",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 251,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "MQTT / WebSocket"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,280)",
    filter: "url(#cvSoftShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 64,
    rx: 12,
    fill: "#fff",
    stroke: "#93c5fd",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 32,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "MQTT Broker")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126,16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 32,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "REST API")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 32,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 39,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "WebSocket")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(298,16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 32,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 31,
    y: 21,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "TLS"))), /*#__PURE__*/React.createElement("path", {
    d: "M550 344 L550 380",
    stroke: "#ea580c",
    strokeWidth: 3,
    markerEnd: "url(#arrowNodflo)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,400)",
    filter: "url(#cvShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 150,
    rx: 16,
    fill: "url(#cvCard)",
    stroke: "#fb923c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 500,
    height: 40,
    rx: 16,
    fill: "url(#nodfloGrad2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 28,
    width: 500,
    height: 12,
    fill: "url(#nodfloGrad2)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 26,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#fff",
    textAnchor: "middle"
  }, "\u2699 NodFlo Workflow Engine"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Events")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(142,60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Conditions")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(254,60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "JavaScript")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366,60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 34,
    rx: 6,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Timers")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 28,
    rx: 5,
    fill: "#fff7ed",
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "MQTT Subscribe")), /*#__PURE__*/React.createElement("path", {
    d: "M160 122 L190 122",
    stroke: "#ea580c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 28,
    rx: 5,
    fill: "#fff7ed",
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Script")), /*#__PURE__*/React.createElement("path", {
    d: "M260 122 L290 122",
    stroke: "#ea580c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(290,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 28,
    rx: 5,
    fill: "#fff7ed",
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 35,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "Database")), /*#__PURE__*/React.createElement("path", {
    d: "M360 122 L390 122",
    stroke: "#ea580c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(390,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 28,
    rx: 5,
    fill: "#fff7ed",
    stroke: "#fdba74",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "MQTT Publish"))), /*#__PURE__*/React.createElement("path", {
    d: "M550 550 L550 590",
    stroke: "#0891b2",
    strokeWidth: 3,
    markerEnd: "url(#arrowEdge)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 558,
    width: 160,
    height: 18,
    rx: 4,
    fill: "#fff",
    stroke: "#0891b2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 550,
    y: 571,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 9,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "Device Tags &amp; Runtime Data"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140,610)",
    filter: "url(#cvShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 820,
    height: 70,
    rx: 12,
    fill: "url(#cvCard)",
    stroke: "#22d3ee",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 410,
    y: 22,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "Edge Devices"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60,34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 28,
    rx: 5,
    fill: "#ecfeff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "\uD83C\uDFED PLC")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190,34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 28,
    rx: 5,
    fill: "#ecfeff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "\uD83C\uDF21 Sensor")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 28,
    rx: 5,
    fill: "#ecfeff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "\uD83D\uDDA5 HMI")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(450,34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 28,
    rx: 5,
    fill: "#ecfeff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "\uD83D\uDD0C Gateway")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(580,34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 28,
    rx: 5,
    fill: "#ecfeff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "\u26A1 Energy Meter")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(710,34)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 28,
    rx: 5,
    fill: "#ecfeff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 18,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#0e7490",
    textAnchor: "middle"
  }, "\uD83D\uDCE1 RTU"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 220,
    rx: 12,
    fill: "#fff",
    stroke: "#bfdbfe",
    strokeWidth: 1,
    filter: "url(#cvSoftShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 28,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Platform Features"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,44)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 MQTT Broker")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,44)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 REST API")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,76)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 WebSocket")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,76)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 Real-Time")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 Device Mgmt")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,108)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u2713 Workflow")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u2713 Dashboards")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,140)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 26,
    rx: 5,
    fill: "#ffedd5"
  }), /*#__PURE__*/React.createElement("text", {
    x: 43,
    y: 17,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#9a3412",
    textAnchor: "middle"
  }, "\u2713 Remote")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16,172)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 30,
    rx: 5,
    fill: "#dbeafe"
  }), /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 19,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 600,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "\u2713 Live Data Logging"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(850,110)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 180,
    rx: 12,
    fill: "#fff",
    stroke: "#bfdbfe",
    strokeWidth: 1,
    filter: "url(#cvSoftShadow)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 28,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#1d4ed8",
    textAnchor: "middle"
  }, "Data Flow"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 52,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#2563eb",
    textAnchor: "middle"
  }, "CloudView"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 72,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#8996a4",
    textAnchor: "middle"
  }, "\u2193"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 90,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#2563eb",
    textAnchor: "middle"
  }, "MQTT / API"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 110,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#8996a4",
    textAnchor: "middle"
  }, "\u2193"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 128,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#ea580c",
    textAnchor: "middle"
  }, "NodFlo Engine"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 148,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fill: "#8996a4",
    textAnchor: "middle"
  }, "\u2193"), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 166,
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fill: "#0891b2",
    textAnchor: "middle"
  }, "Processed Data")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudviewNodfloArchitecture);
export default __webpack_public_path__ + "static/media/cloudview_nodflo_architecture.ef4608e82911a21d05637fdf8ee9070b.svg";
export { ForwardRef as ReactComponent };